/** @typedef {import("../../api/types").Product} Product */
import React, {useEffect, useState} from "react";
import axios from "axios";
import {Link, useParams} from "react-router-dom";
import {Alert, Button, Card, CardBody, Container, Spinner} from "reactstrap";
import Field from "../../shared/components/Field";
import ServiceItemStatusBadge from "../serviceItems/components/ServiceItemStatusBadge";
import {formatMoney} from "../../shared/utils/format";
import ListLink from "../../shared/components/ListLink";
import IconLabel from "../../shared/components/IconLabel";
import {PencilIcon} from "../../shared/components/icons";

const PRODUCTS_URL = "/os/api/products/";

const ProductDetail = () => {
    const {id} = useParams();
    const [product, setProduct] = useState(/** @type {Product|null} */ (null));
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const controller = new AbortController();
        setLoading(true);
        setError(null);
        setProduct(null);

        axios
            .get(`${PRODUCTS_URL}${encodeURIComponent(id)}/`, {signal: controller.signal})
            .then(({data}) => setProduct(data))
            .catch((err) => {
                if (axios.isCancel(err)) return;
                setError(
                    err.response?.status === 404 ? "Produto não encontrado." : "Não foi possível carregar o produto."
                );
            })
            .finally(() => {
                if (!controller.signal.aborted) setLoading(false);
            });

        return () => controller.abort();
    }, [id]);

    return (
        <Container className="mt-4 mb-5">
            <ListLink basePath="/products">&larr; Produtos</ListLink>
            {loading && (
                <div className="text-center mt-4">
                    <Spinner />
                </div>
            )}
            {error && (
                <Alert color="danger" className="mt-3">
                    {error}
                </Alert>
            )}
            {product && (
                <>
                    <div className="d-flex justify-content-between align-products-center mt-3 mb-3">
                        <h3 className="mb-0">{product.name}</h3>
                        <Button color="primary" outline tag={Link} to={`/products/${id}/edit`}>
                            <IconLabel icon={<PencilIcon size={16} />}>Editar</IconLabel>
                        </Button>
                    </div>
                    <Card>
                        <CardBody>
                            <Field label="Descrição" value={product.description} preserveLineBreaks />
                            <Field label="Valor base" value={product.base_value}>
                                {formatMoney(product.base_value, product.currency)}
                            </Field>
                            <Field label="Custo" value={product.cost}>
                                {formatMoney(product.cost, product.currency)}
                            </Field>
                            <Field label="Situação" value={product.status}>
                                <ServiceItemStatusBadge status={product.status} />
                            </Field>
                        </CardBody>
                    </Card>
                </>
            )}
        </Container>
    );
};

export default ProductDetail;
